/** A list-view row: room for two lines (the date range, the countdown over its spots). */
export const ORG_REGISTRATION_ROW_HEIGHT = 64
